"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APDropdownMenu = void 0;
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Menu_1 = __importDefault(require("@material-ui/core/Menu"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
var react_1 = __importStar(require("react"));
function APDropdownMenu(_a) {
    var options = _a.options, initial = _a.initial, onSelect = _a.onSelect, style = _a.style;
    var _b = react_1.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = react_1.useState(initial !== null && initial !== void 0 ? initial : options[0]), value = _c[0], setValue = _c[1];
    var handleClose = function () {
        setAnchorEl(null);
    };
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { onClick: function (event) {
                setAnchorEl(event.currentTarget);
            }, style: __assign(__assign({ fontSize: '16px' }, style), { paddingLeft: "16px", minWidth: "90px" }) },
            value,
            " ",
            react_1.default.createElement(ArrowDropDown_1.default, { fontSize: 'large' })),
        react_1.default.createElement(Menu_1.default, { anchorEl: anchorEl, getContentAnchorEl: null, keepMounted: true, open: Boolean(anchorEl), anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'center' }, onClose: handleClose }, options.map(function (option, index) {
            return react_1.default.createElement(MenuItem_1.default, { key: index, onClick: function () {
                    onSelect(option);
                    setValue(option);
                    handleClose();
                } }, option);
        })));
}
exports.APDropdownMenu = APDropdownMenu;
